<h1 mat-dialog-title>Payment Authorization (warning)</h1>
<div mat-dialog-content>
  <p>
    Please review Payment Authorization form. Payment authorization is used to authorize to whom the Earthquake Brace + Bolt incentive payment is to be paid.
  </p>
</div>
<div mat-dialog-actions style="margin-top: 9px !important; float: right !important;">
  <button mat-raised-button
    (click)="onClickOk()">
    OK
  </button>
</div>